// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedViewPanelsContainer_root"};